import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import Cropper from "react-cropper"

import { Button } from "components"
import classes from "./FuwEditImage.module.scss"

const FuwEditImage = props => {
  const {
    setTab,
    setFiles,
    aspectRatio,
    selectedFileIdForEdit,
    setSelectedFileIdForEdit
  } = props

  const [t] = useTranslation()

  const [cropping, setCropping] = useState(false)

  const cropperRef = useRef(null)

  const getCropData = async () => {
    setCropping(true)

    const cropper = cropperRef.current.cropper

    const croppedWidth = cropper.getData().width

    const canvas =
      await cropper.getCroppedCanvas({
        width: croppedWidth > 1280 ? 1280 : croppedWidth
      })

    const newCanvas = document.createElement("canvas")

    newCanvas.width = canvas.width
    newCanvas.height = canvas.height

    const ctx = newCanvas.getContext("2d")

    ctx.fillStyle = "#ffffff"
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    ctx.drawImage(canvas, 0, 0,
      canvas.width, canvas.height, 0, 0,
      newCanvas.width, newCanvas.height
    )

    newCanvas.toBlob((blob) => {
      setFiles(prev =>
        prev.map(f =>
          f.id === selectedFileIdForEdit.id
            ?
            {
              ...f,
              blob,
              isFile: true,
              edited: true,
              url: URL.createObjectURL(blob)
            }
            :
            f
        )
      )

      setTab("files")

      setSelectedFileIdForEdit(null)
    }, "image/jpeg")

    setCropping(false)
  }

  const handleCancel = () => {
    setTab("files")

    setSelectedFileIdForEdit(null)
  }

  return (
    <div className={classes["container"]}>
      <div className={classes["wrapper"]}>
        <Cropper
          src={selectedFileIdForEdit.url}
          aspectRatio={aspectRatio}
          className={classes["cropper"]}
          viewMode={1}
          zoomable={false}
          ref={cropperRef}
        />
      </div>
      <div className={classes["footer"]}>
        <Button
          color="danger"
          onClick={handleCancel}
        >
          {t("انصراف")}
        </Button>
        <Button
          color="success"
          disabled={cropping}
          onClick={getCropData}
        >
          {cropping ? t("در_حال_برش") : t("برش")}
        </Button>
      </div>
    </div>
  )
}

export default FuwEditImage